module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.quoteList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return _vm._l((_vm.objQuoteSettings), function(item) {
          return (item.checked) ? _c('td', {
            staticClass: "text-xs-right"
          }, [_c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncFormatColumn(props.item, item.id))
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncEditStatus(props.item, item.id)
              }
            }
          })]) : _vm._e()
        })
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}